import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { I18n } from 'common'
import styled from 'styled-components'
import { useUiStateStore } from '../../../../../src/store/uiState/UiStateStore'
import { useVehicleWidgetStore } from '../../../../../src/features/search/VehicleSearch/store/VehicleWidgetStore'
import { Hyperlink } from '../../../../../src/ui-components/util/Hyperlink'
import carIcon from '../../assets/images/might-not-match-vehicle.svg'
import { useSearchStore } from 'src/store/search/SearchStore'
import { formatVehicleDisplayWithOutEngine } from 'src/helpers/utils'

const FitmentDisclaimer = observer((): ReactElement => {
  const uiStore = useUiStateStore()
  const searchStore = useSearchStore()
  const vehicleWidgetStore = useVehicleWidgetStore()
  const { currentVehicle } = searchStore
  const addVehicleCallback = uiStore.skipAddVehicleCallback()

  const handleAddVehicle = () => {
    vehicleWidgetStore.setIsDrawerOpened(true)
    vehicleWidgetStore.setAfterAddVehicle(addVehicleCallback)
  }

  return (
    <>
      {currentVehicle?.engine?.value && (
        <Wrapper>
          <CardIcon src={carIcon} alt="Car Icon" />
          <Message>
            <I18n name="thesePartsMayNotFitYour" />{' '}
            {formatVehicleDisplayWithOutEngine(currentVehicle)}
          </Message>
        </Wrapper>
      )}
      {!currentVehicle?.engine?.value && addVehicleCallback && (
        <Wrapper>
          <CardIcon src={carIcon} alt="Car Icon" />
          <Message>
            <I18n name="pleaseAddAVehicleToEnsureFitment" />
            &nbsp;
          </Message>
          <Hyperlink action={handleAddVehicle}>
            <I18n name="addVehicle" />
          </Hyperlink>
        </Wrapper>
      )}
    </>
  )
})

const Wrapper = styled.div`
  background: #fafafa;
  height: 48px;
  display: flex;
  align-items: center;
  padding: 12px 20px;
  margin-top: 2px;
`

const Message = styled.p`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  margin: 0px 5px 0px 16px;
`

const CardIcon = styled.img`
  height: 24px;
  width: 24px;
`

export default FitmentDisclaimer
